export default {
  employeeList: [],
  dbAccessList: [],
  personalInfo: '',
  organisationInfo: '',
  dbRecordsList: [],
  employeeInfoForEdit: [],
  editEmployeeAnswer: '',
  dbListForNewEmployee: [],
  errors: {
    employeeListError: null,
    personalInfoError: null,
    organisationInfoError: null,
    dbAccessListError: null,
    dbRecordsListError: null,
    deleteEmployeeError: null,
    employeeInfoForEditError: null,
    editEmployeeError: null,
    dbListForNewEmployeeError: null,
    addNewEmployeeError: null
  },
  loading: {
    employeeListLoading: false,
    personalInn: false,
    organisationInn: false,
    addNewEmployee: false,
    newRecordResponseError: false,
    editEmployeeLoading: false,
    deleteEmployeeLoading: false
  }
}



// WEBPACK FOOTER //
// ./src/store/employee/state.js